/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import { useEffect, useState, useCallback, useMemo } from 'react';
// eslint-disable-next-line no-unused-vars
import { Col, Row, Button } from 'react-bootstrap';
import { withFormik } from 'formik';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import compose from 'recompose/compose';
import cln from 'classnames';

import { withStore } from 'store';
import { updateGiftTable } from 'store/actions/giftTable';
import { fetchProductDetails } from 'store/actions/gifts';
import { showErrorResponseModal } from 'store/actions/commons';

import { getProductsById } from 'services/api/products';
import { useStorage64, useFirstRender, useWindowSize } from 'hooks';

import { Select, Modal } from 'components';
import GiftsList from 'components/gifts-table/GiftsList/indexNew';
import GiftItemNEW from 'components/gifts-table/GiftsList/GiftItem/indexNew';
import AddGiftByURL from 'components/gifts-table/AddGiftByURL';
import FilterWidget from 'components/gifts-table/GiftsList/FilterWidget';
import TableWelcomeMessage from 'components/gifts-table/TableWelcomeMessage';
import { PrintQR } from 'components/Cards';
import GiftsFilter from 'components/gifts-table/GiftsList/GiftsFilter';

import { isAdminPage } from 'util/navigation';
import { transformForSelect } from 'util/transformHelpers';
import { CURRENT_GIFT_TABLE , SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { VERSIONS } from 'constants/versions';
import { RECOMMENDATION_TYPES } from 'constants/catalogs/recommendationTypes';
import { INITIAL_PAGES } from 'constants/values/lists';

import { removeStorage } from 'pages/Header/Content/functions/storageBase64';
import { Link } from 'react-router-dom';
import barcodePrimary from 'assets/img/iconCategoria.svg';
// import { is } from 'date-fns/locale';
import { mapPropsToValues } from './formikProps';
import { mapStateToProps, mapDispatchToProps } from './storeProps';
import propTypes from './propTypes';
import {
  RECOMMENDATIONS_OPTION,
  RECOMMENDATIONS_VALUE,
  LIMIT_OF_ITEMS
} from './constants';
import styles from './styles.module.scss';


function AddGiftTable({
    dispatch,
    tableInfo,
    addGifts = false,
    externalLink = false,
    values: formikValues,
    setFieldValue,
    listOfGifts,
    categories = [],
    selectedCategory: recommendedCategory,
    showRecommendations,
    fetchDynamicConfiguration,
    fetchProductsOfDynamicCategory,
    dynamicRecommendations = [],
    addProduct,
    deleteProduct,
    giftTableProducts,
    changeGiftTableProductsPage,
    changeGiftTableProductsSort,
    changeRecommendationProductsOrder,
    setGiftsProductsParams,
    setShowRecommendations,
    fetchProductsOfSelectedCategory,
    fetchProductsByRecommendations,
    fetchAllProductsOfRecommendations,
    resetGiftsProducts,
    filters,
    withRecommendations,
    emptyRecommendations,
    categoryLoadError,
    fetchGiftsByFilters,
    fetchGiftTableInfo,
    cleanGiftsProductsParams,
    changeRecommendationProductsPage,
    changeGiftsProductsPageAndFetch,
    giftsParams,
    setRecommendedCategory,
    showFilterByOrder
}) {
    const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
    const [categoryError, setCategoryError] = useState(true);
    const [showProduct, setShowProduct] = useState(false);
    const [productByUrl, setProductByUrl] = useState({});
    const [hideGiftByUrl, setHideGiftByUrl] = useState(false);
    const [fallbackCategory, setFallbackCategory] = useState(false);
    const [giftsListHelpers, setGiftsListHelpers] = useState({});
    const [filterHelpers, setFilerHelpers] = useState({});
    const [hasFetched, setHasFetched] = useState(false);
    const [filtersHasFetched, setFiltersHasFetched] = useState(false);
    const [firstCategory, setFirstCategory] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [giftTableProduct, setGiftTableProduct] = useState({});
    const [productosid, setProductosid] = useState([]);
    const [brands, setBrands] = useState([]);
    const [listaProduct,setListaProduct] = useState('');
    const [loading, setLoading] = useState(true);

    const isFirstRender = useFirstRender();
    const { isMobile } = useWindowSize({ largeMobile: true })[1];

    const { categories: filterCategories = [] } = filters;
    const { filterCategory } = formikValues;


    const hasDynamic = useMemo(
        () => tableInfo.recommendation_type === RECOMMENDATION_TYPES.DYNAMIC,
        [tableInfo.recommendation_type]
    );

    const recommendedCategories = useMemo(
        () => (hasDynamic ? dynamicRecommendations : categories),
        [hasDynamic, dynamicRecommendations, categories]
    );
    const changePageAction = useMemo(
        () =>
        showRecommendations
            ? changeRecommendationProductsPage
            : changeGiftsProductsPageAndFetch,
        [
        showRecommendations,
        changeRecommendationProductsPage,
        changeGiftsProductsPageAndFetch
        ]
    );

    // console.log(':  storageGiftTable : ',storageGiftTable,' recommendedCategories: ',recommendedCategories,' filters: ',filters)

    // Check mapPropsToValues of GiftsList (in config file) to get context of this sortName
    const sortName = useMemo(() => {
        if (!addGifts) return 'sortMyProducts';
        return showRecommendations ? 'sortAddProducts' : 'sort';
    }, [addGifts, showRecommendations]);


    const saveField = (values) => {

        console.log('AddGiftTable - saveField: ',values)   
        dispatch(updateGiftTable(values));
    };



    /* click al agregar producto */
    const handleAddProduct = async (product) => {
        console.log('AddGiftTable - handleAddProduct: ',product)
        let success = false;
        const isActive = product.status && product.stock;
        const response = await getProductDetail(product, false, true);
        success = response === null;
        if (!_isEmpty(response)) {
            success = await addProduct(response);
        }
        !success && isActive && dispatch(showErrorResponseModal('Intenta más tarde'));
        return success;
    };

    /* click al eliminar producto */
    const handleDeleteProduct = async (product) => {
        console.log('AddGiftTable - handleDeleteProduct: ',product, 'tableId: ',tableInfo)
        const response = await deleteProduct({ tableId: tableInfo?.id, productId: product.id });
        !response && dispatch(showErrorResponseModal('Intenta más tarde'));
        return response;
    };

    const handleUpdateProduct = () => {};

    
    /* al parecer entra cuando es talla color */
    const handleSearchByURL = (productData) => {
        if (productData) {
            console.log('AddGiftTable - handleSearchByURL: ',productData)
            setProductByUrl(productData);
            setShowProduct(true);
        }
    };

    const handleClose = (isSuccess = false) => {
        removeStorage('isByPass');
        removeStorage('isChangedGiftTable');
        removeStorage(SEARS_PRODUCT);
        removeStorage(TOTAL_GIFT_TABLES);
        const productId = window.localStorage.getItem('product_id');
        const elem = document.getElementById(productId);
        window.localStorage.removeItem('product_id');
        productId && elem && elem.click();
        const success = (typeof isSuccess === 'boolean' && isSuccess);
        success && document.getElementById('close-modal').click();
        !success && setShowProduct(false);
        setHideGiftByUrl(false);
    };

    const handleAddGifts = (product) => {
        
        getProductDetail(product, true).then((payload) => {
            if (payload) {
                console.log('AddGiftTable - handleAddGifts: ',product,' payload: ',payload)
                addProduct(payload);
                setHideGiftByUrl(true);
            }
        });
    };

    /* recibe producto al parecer puede ser de anteater o api */
    const getProductDetail = async (product, firedModal) => {
        try {

            console.log('AddGiftTable - getProductDetail: ',product)

            // Anteater, Sears or Modal
            const product_id = product.id || product.product_id || product.producto;
            const productSelected = _get(giftTableProducts, 'results.allElements', []);
            const isSelected = productSelected.filter(
                (ps) => +ps.product_id === +product_id
            );

            // Get Product Detail
            const response = await getProductsById([product_id]);
            const detail = response && response.data?.length ? response.data[0] : null;

            // Product without variants
            product.ean = detail?.ean;
            product.sku = detail?.sku;
            product.variant_id = null;
            product.children_sku = null;

            // Fired Catalog - Product with variants (1st step) -> Show modal
            if (!firedModal && detail.variations && !isSelected.length) {
                // eslint-disable-next-line no-shadow
                const onSuccess = (product_id) => {
                    handleSearchByURL(product_id);
                };
                const onError = () => {
                    console.log('ERROR!');
                };
                dispatch(
                    fetchProductDetails({ productId: product_id, onSuccess, onError })
                );
                return null;
            }

            // SearchByUrl or Fired Catalog - Product with variants (2nd step) -> From modal
            if (firedModal || isSelected.length) {
                const dataVariant = product.variant || isSelected[0]?.children_sku;
                const variant = detail?.variations?.filter((v) => v.sku === dataVariant);
                product.variant_id = variant?.length ? variant[0].id : null;
                product.children_sku = variant?.length ? variant[0].sku : null;
            }

            return product;
        }
        catch(error) {
            return {};
        }
    };


    const handleCloseSuccessMessage = () => {
        handleClose(true);
    };

    const resetRecommendedCategory = () => {
        setFieldValue('selectedCategory', '');
        setRecommendedCategory({});
    };


    const handlePaginationChange = (newPages) => {
        if (_isEmpty(tableInfo) || isFirstRender) return;

        if (!addGifts) {
            changeGiftTableProductsPage(newPages);
        } else {
            if (!showRecommendations) resetRecommendedCategory();
            changePageAction({ ...newPages, hasDynamic });
        }
    };


    const handleOrderChange = (evt) => {
        const { value } = evt.target;

        if (value === undefined) return;

        if (!addGifts) {
            changeGiftTableProductsSort(value);
        } else if (showRecommendations) {
            changeRecommendationProductsOrder(value);
        }
        setGiftsProductsParams({ [sortName]: value });
    };


    const handleFilterClean = () => {
        if (showRecommendations) {
            setFieldValue('filterCategory', '');
            filterHelpers?.setFieldValue('category', '');
            handleClickSuggestions({ hasDynamic });
        }
    };


    const handleGetHelpers = useCallback((helpers) => {
        
        console.log('AddGiftTable - handleGetHelpers: ',helpers)
        
        setGiftsListHelpers(helpers);
    }, []);


    const handleGetFilterWidgetHelpers = useCallback((helpers) => {

        console.log('AddGiftTable - handleGetFilterWidgetHelpers: ',helpers)

        setFilerHelpers(helpers);
    }, []);


    const handleSelectCategory = (category, isRecommendation = false) => {
        if (isFirstRender) return;
        if (categoryLoadError && category !== filterCategories[0]?.id_cat) {
            setCategoryError(false);
        }

        cleanGiftsProductsParams();
        setGiftsProductsParams({ category });

        setFieldValue('filterCategory', category);
        giftsListHelpers?.setFieldValue('section', '');
        giftsListHelpers?.setFieldValue('brand', '');

        if (!isRecommendation) {
            resetRecommendedCategory();
            setShowRecommendations(false);
        }

        setHasFetched(true);
    };


    // Fetching then change category
    useEffect(() => {
        if (!isFirstRender && giftsParams.category && hasFetched) {
            changePageAction(INITIAL_PAGES);
        }
    }, [giftsParams.category]);

    const handleFilterChange = () => {
        if (!_isEmpty(tableInfo) && !isFirstRender) {
            changeGiftsProductsPageAndFetch(INITIAL_PAGES);
        }
    };

    const getRecommendedCat = (id) =>
        recommendedCategories.find((current) => current.category_sears_id === id);

    const handleFilterCategoryChange = (id) => {
        const category = getRecommendedCat(id);

        console.log('AddGiftTable - handleFilterCategoryChange: ',id)

        if (category) {
            setRecommendedCategory(category);
        giftsListHelpers?.resetOrder();
        } else {
            setRecommendedCategory({});
            fetchAllProductsOfRecommendations({ hasDynamic });
        }
        setShowFilters(false);
    };

    const handleClickSuggestions = () => {
        const category = getRecommendedCat(firstCategory);

        console.log('AddGiftTable - handleClickSuggestions: ',firstCategory)

        if (category) {
            setRecommendedCategory(category);
        } else {
            fetchAllProductsOfRecommendations({ hasDynamic });
        }
        setShowRecommendations(true);
        giftsListHelpers?.setFieldValue('category', firstCategory);
        setFieldValue('filterCategory', '');
    };

    const handleChangeMobileCategory = (evt) => {
        const { value } = evt.target;
        if (value === RECOMMENDATIONS_VALUE) {
            handleClickSuggestions();
        } else {
            handleSelectCategory(value);
        }
    };

    const handleFiltersClick = () => {
        setShowFilters(true);
    };

    const handleFilterSubmit = () => {
        setShowFilters(false);
    };

    useEffect(() => {
        if (showFilters && !isMobile) {
            setShowFilters(false);
        }
    }, [showFilters, isMobile]);

    // For add gifts page, reset products on unmount component
    useEffect(() => () => {
        if (addGifts) resetGiftsProducts();
    },[]);

    // First get table info, this is essential for data fetching
    useEffect(() => {
        if ( !isAdminPage() &&
            _isEmpty(tableInfo) &&
            storageGiftTable.id &&
            addGifts
        ) {
            fetchGiftTableInfo({ id: storageGiftTable.id, showLoader: false });
        }
    }, [tableInfo, storageGiftTable, addGifts]);

    // Second, fetch filters and categories on second plane, this is essential for products filters and the process not continue without this data
    useEffect(() => {
        if (addGifts && !_isEmpty(tableInfo)) {
            const handleSuccess = () => {
                setFiltersHasFetched(true);
            };
            fetchGiftsByFilters({
                onlyFilters: true,
                onSuccess: handleSuccess,
            });
        }
    }, [addGifts, tableInfo]);


    // Third, get products by recommendations
    useEffect(() => {
        if (_isEmpty(tableInfo) || !addGifts || !filtersHasFetched) return;

        if (hasDynamic) {
            // For dynamic recommendation, first fetch configuration, this contains the parameters and filters
            const payload = {
                eventTypeId: tableInfo.type.id,
                guestRangeId: tableInfo.guest_range.id
            };
            fetchDynamicConfiguration(payload);
        } else {
            fetchProductsByRecommendations();
        }
    }, [tableInfo, addGifts, hasDynamic, filtersHasFetched]);


    // fourth, get products by recommendations for selected category
    useEffect(() => {
        if (_isEmpty(recommendedCategory) || !addGifts) return;

        if (hasDynamic) {
            fetchProductsOfDynamicCategory(recommendedCategory);
        } else {
            fetchProductsOfSelectedCategory();
        }
        setHasFetched(true);
    }, [recommendedCategory, hasDynamic]);


    // Set fallback category in the case that the recommendations category is empty
    useEffect(() => {
        if (!fallbackCategory && filterCategories.length) {
            setFallbackCategory(filterCategories[0].id_cat);
        }
    }, [filterCategories]);


    // If the recommendations has empty, set fallback category
    useEffect(() => {
        if (emptyRecommendations && fallbackCategory) {
            handleSelectCategory(fallbackCategory);
        }
    }, [emptyRecommendations, fallbackCategory]);


    // If the category has invalid, set fallback category
    useEffect(() => {
        if (categoryLoadError && fallbackCategory) {
            handleSelectCategory(fallbackCategory);
        }
    }, [categoryLoadError, fallbackCategory]);


    useEffect(() => {
        if (emptyRecommendations && !hasDynamic && fallbackCategory) {
            handleSelectCategory(fallbackCategory);
        }
    }, [hasDynamic, fallbackCategory]);

    // console.log('giftTableProducts',giftTableProducts);

    // Inicia codigo para poner filtro de mi mesa nuevo desarrollo
    /* const [productosid, setProductosid] = useState([]);

    useEffect(() => {
        if (giftTableProducts.results?.allElements) {
        const allIdproducts = [...new Set(giftTableProducts.results.allElements.map(Productos => Productos.id))];
        setProductosid(allIdproducts);
        }
    }, [isMobile,hasDynamic,giftTableProducts]); */  


    useEffect(() => {
        if (giftTableProducts.results?.allElements) {

            console.log('AddGiftTable - useEffect - giftTableProducts.results: ',giftTableProducts.results)

            const allIdproducts = giftTableProducts.results.allElements.map(Productos => Productos.id);
            setProductosid(allIdproducts);
        }
    }, [giftTableProducts.results]);
    // console.log('idproductos',productosid);

  

    useEffect(() => {
        let isMounted = true;

        const obtenerBrands = async () => {
            try {
                setLoading(true); // Establecer el estado de carga a true al iniciar la obtención de las marcas

                const uniqueBrands = [];
                const arrayBrands = [];

                const promises = productosid.map(async (productId) => {
                    try {
                        const productData = await getProductsById([productId]);
                        if (isMounted) {
                            const detail = productData?.data?.[0];
                            const categoria = detail?.categories?.[0]?.[detail.categories[0].length - 1];
                            const nombrecategoria = categoria?.name;

                            if (detail && nombrecategoria) {
                                const newDataArray = {
                                    id: detail.id,
                                    description: detail.description,
                                    item: detail.id,
                                    title: detail.title,
                                    image: detail.pictures?.[0]?.thumbnail || '',
                                    msrp: detail.pricing?.list_price,
                                    price: detail.pricing?.sales_price,
                                    c_descuento: detail.pricing?.percentage_discount,
                                    product_id: detail.id,
                                    stock: detail.stock,
                                    review: String(detail.rating?.average_score),
                                    total_review: detail.rating?.total_reviews,
                                    status: detail.status || detail.is_active,
                                    categories: nombrecategoria,
                                    seller: detail.seller || [],
                                    variant_id: detail.variant_id,
                                    variant_sku: detail.variant_sku,
                                    sku: detail.sku,
                                    ean: detail.ean,
                                    division: detail.division,
                                    variations: detail.variations,
                                    brand: detail.brand,
                                };

                                arrayBrands.push(newDataArray);

                                if (!uniqueBrands.includes(nombrecategoria)) {
                                    uniqueBrands.push(nombrecategoria);
                                }
                            }
                        }
                    } catch (error) {
                        console.error(`Error al obtener la categoría para el producto con ID ${productId}`);
                    }
                });

                await Promise.all(promises);

                if (isMounted) {
                    setBrands(uniqueBrands);
                    setListaProduct(arrayBrands);
                }
            } catch (error) {
                console.error('Error al obtener las marcas de los productos', error);
            } finally {
                if (isMounted) {
                    setLoading(false); // Establecer el estado de carga a false una vez finalizada la obtención de las marcas
                }
            }
        };

        obtenerBrands();

        return () => {
            isMounted = false;
        };
    }, [giftTableProducts]);

    // console.log('brands',brands);
    // console.log('listaProduct',listaProduct);

    /* const handleFilterByBrand = (selectedBrand) => {
        console.log('selectedBrand', selectedBrand);

        // Verificar si 'data' tiene la estructura correcta
        if (giftTableProducts && giftTableProducts.results && Array.isArray(giftTableProducts.results.list)) {
        // Si no hay una marca seleccionada, mostrar todos los productos
        if (!selectedBrand) {
            setGiftTableProduct({});
        } else {
            // Filtrar los productos según la marca seleccionada
            const filteredProducts = {
            params:giftTableProducts.params,
            results: {
                allElements: giftTableProducts.results.allElements,
                error:false,
                errorMessage:'',
                list: listaProduct.filter(product => product.categories === selectedBrand)
            }
            };
            setGiftTableProduct(filteredProducts);
        }
        }
    }; */

    const handleFilterByBrand = (selectedBrand) => {
    // console.log('selectedBrand', selectedBrand);

        // Verificar si 'data' tiene la estructura correcta
        if (giftTableProducts?.results?.list && Array.isArray(giftTableProducts.results.list)) {
            // Si no hay una marca seleccionada, mostrar todos los productos
            if (!selectedBrand) {
                setGiftTableProduct({});
            } else {
                // Filtrar los productos según la marca seleccionada
                const filteredList = listaProduct.filter(product => product.categories === selectedBrand);
                const filteredProducts = {
                    ...giftTableProducts,
                    results: {
                    ...giftTableProducts.results,
                    list: filteredList
                    }
                };
                setGiftTableProduct(filteredProducts);
            }
        }
    };


    // console.log('giftTableProduct',giftTableProduct);
    // Finaliza codigo para poner filtro de mi mesa nuevo desarrollo

    // eslint-disable-next-line no-unused-vars
    const renderWelcomeMessage = (
        <TableWelcomeMessage
        onSave={saveField}
        value={tableInfo?.welcome_message}
        onlyView={addGifts || externalLink}
        />
    );

    const [iconsData, setIconsData] = useState({});


    /* llamada a categorias para traer los iconos */
    useEffect(() => {
        const fetchIconsData = async () => {
            try {
                const response = await fetch('https://seapi.sears.com.mx/categories/v1/category');
                const data = await response.json();
                if (data && data.data) {
                // Create an object where the category names are the keys and the icon URLs are the values
                const icons = data.data.reduce((acc, category) => {
                    acc[category.name] = category.icon;
                    return acc;
                }, {});
                setIconsData(icons);
                }
            } catch (error) {
                console.error('Error fetching icons data:', error);
            }
        };

        fetchIconsData();
    }, []);

    useEffect(()=>{
        console.log('.-.-.-.--.-.-.-.-.');
        console.log('giftTableProducts: ',giftTableProducts);
        console.log('.-.-.-.--.-.-.-.-.');

    },[giftTableProducts])



    /* esto llevara el hook */
  const [giftGetResponse, setGiftGetResponse] = useState(null)
  const getGiftProduct = async () => {
    const giftIdEvent = 2222

    if(giftIdEvent ){
      const response = await fetch(`https://seapi-gamma.dev.sears.com.mx/gift-table/v1/gift-table/${giftIdEvent}`);
      const data = await response.json();
      setGiftGetResponse(data)
    }
  }

  const [ready, setReady] = useState(true)
  useEffect(() => {
    if(ready){
      setReady(false)
      getGiftProduct()
    }
  },[ready])


  useEffect(() => {
    if(giftGetResponse  && giftGetResponse?.data && giftGetResponse?.data?.gifts){
      console.log('giftGetResponse: ',giftGetResponse)
    }
  },[giftGetResponse])


  return (
        <>
            <Modal
                show={showProduct}
                onClose={handleClose}
                withActionButtons={false}
                variant="completed"
                variantOnlyInMobile
                dialogClassName={styles.modalDialog}
                containerClassName={cln(hideGiftByUrl && 'd-none')}
            >
                <GiftItemNEW
                    item={productByUrl}
                    id={1}
                    type="bigDetails"
                    stockMock
                    selected
                    version={VERSIONS.V2}
                    onUpdateGift={handleUpdateProduct}
                    onAddGift={handleAddGifts}
                    onCloseSuccessMessage={handleCloseSuccessMessage}
                    giftTableId={tableInfo?.id}
                    showSuccessModal
                    showAllImages={false}
                />
        </Modal>

        <div className={styles.container}>
            <Row>
                {!externalLink && addGifts && (
                    <>
                        <Col xs={12} className="d-lg-none">
                            <PrintQR variant="primary" alt="Escanear código QR" />
                        </Col>

                        <Col xs={12} className="d-lg-none">
                            <div className="mb-4">
                                <AddGiftByURL onSearch={handleSearchByURL} />
                            </div>
                        </Col>
                    </>
                )}


        
                {addGifts && (
                    <>
                        {isMobile && (
                            <Col xs={12} className='text-center pb-4'>
                                Agregar por categoría
                            </Col>
                        )}
                    
                        <Col xs={12} className={!isMobile?'d-none d-lg-flex align-items-start':'d-flex align-items-start'}>

                            <div className={styles.categoriesContainer}>
                                {filterCategories.map(({ external_id: id, name }) => {
                                    if (name === 'MarketPlace') return null;
                                    const hasActive = Boolean(filterCategory && filterCategory === id && !showRecommendations);
                                    const hasActiveByError =
                                        categoryError && categoryLoadError && id === filterCategories[0]?.id_cat;
                                    const iconSrc = iconsData[name] ? iconsData[name] : barcodePrimary;

                                    return (
                                        <Link
                                            key={id}
                                            variant={hasActive || hasActiveByError ? 'primary' : 'secondary'}
                                            className='mr-2 d-flex flex-column align-items-center'
                                            onClick={() => handleSelectCategory(id)}
                                        >
                                            <img
                                                src={iconSrc}
                                                style={{ }}
                                                alt={name.toLowerCase()}
                                                className='rounded'
                                            />
                                            <span style={{ color: 'black', fontFamily: 'Helvetica' }}>{name}</span>
                                        </Link>
                                    );
                                })}
                            </div>
                        </Col>

                        <Col xs={12} className={styles.title}>
                            {!isMobile && (
                                <div className="d-lg-none mb-2">
                                    <Select
                                        name="filterCategory"
                                        options={[
                                            withRecommendations ? RECOMMENDATIONS_OPTION : false
                                        ]
                                        .filter(Boolean)
                                        .concat(
                                            transformForSelect(filterCategories, 'id_cat', 'nombre')
                                        )}
                                        variant="primary"
                                        defaultValue={filterCategory}
                                        onChange={handleChangeMobileCategory}
                                    />
                                </div>
                            )}
                            {!isMobile ? (
                                <h2 className="text-center text-md-left">
                                    Sugerencias para ti
                                </h2>
                                ) : (
                                <div className='text-center text-md-left'>
                                    Sugerencias para ti
                                </div>
                            )}
                            
                        </Col>
                    </>
                )}


                {/* Bloque lateral izquierdo de /agregar-regalos/ desktop */}
                <Col xs={12} lg={3} className={`${styles.filters} d-none d-lg-block`}>                                        
                    {addGifts && 
                        <>
                            {/* <div>PrintQR = Escanear código QR</div> */}
                            <PrintQR variant="primary" alt="Escanear código QR" />
                        </>
                    }
                    {addGifts && (
                        <div className="mb-4">
                            {/* <div>AddGiftByURL = agrega prod por url</div> */}
                            <AddGiftByURL onSearch={handleSearchByURL} />
                        </div>
                    )}
                    {addGifts && (
                        <div className="PickPresents__filters">
                            {/* <div>FilterWidget = filtro categorias</div> */}
                            <FilterWidget
                                isModal={isMobile}
                                show={showFilters}
                                onClose={() => setShowFilters(false)}
                                onFilterChange={handleFilterChange}
                                onCategoryChange={handleFilterCategoryChange}
                                onCleanFilters={handleFilterClean}
                                selectedCategory={recommendedCategory}
                                recommendedCategories={recommendedCategories}
                                getHelpers={handleGetFilterWidgetHelpers}
                                firstCategory={firstCategory}
                                setFirstCategory={setFirstCategory}
                                onFilterSubmit={handleFilterSubmit}
                            />
                        </div>
                    )}
                </Col>

                {/* Bloque lateral derecho de /agregar-regalos/ desktop */}
                <Col xs={12} lg={9}>
                    {addGifts && (
                        <GiftsList
                            title={!addGifts ? 'Mesa de regalos' : ''}
                            data={addGifts ? listOfGifts : giftTableProducts}
                            selected={_get(giftTableProducts, 'results.allElements', [])}
                            onAddItem={handleAddProduct}
                            onUpdateItem={handleAddProduct}
                            onDeleteItem={handleDeleteProduct}
                            defaultMode={addGifts ? 'pick' : 'list'}
                            onPaginationChange={handlePaginationChange}
                            onOrderChange={handleOrderChange}
                            onClickFilters={handleFiltersClick}
                            sortName={sortName}
                            getHelpers={handleGetHelpers}
                            withMobileList
                            addGifts={addGifts}
                            showFilterByOrder={showFilterByOrder}
                            totalLimit={LIMIT_OF_ITEMS}
                        />
                    )}
                </Col>
            </Row>
      </div>
    </>
  );
}

AddGiftTable.propTypes = propTypes;

export default compose(
  withStore({ mapStateToProps, mapDispatchToProps }),
  withFormik({ mapPropsToValues })
)(AddGiftTable);
